import { TorusGeometry, MeshStandardMaterial, Mesh } from 'three';
import * as CANNON from 'cannon-es';

export default class Coin {
    constructor(GAME, position) {
        this.GAME = GAME;

        this.size = 0.5;

        this.position = { x: 0, y: 5, z: -26 };

        if (position === 'H' || position === 'h') {
            this.position = { x: 0, y: 13, z: -26 };
        }

        if (position === 'M' || position === 'm') {
            this.position = { x: 0, y: 9, z: -26 };
        }

        if (position === 'L' || position === 'l') {
            this.position = { x: 0, y: 5, z: -26 };
        }

        let isHandled = false;
        this.create();
    }

    destroy() {
        this.GAME.scene.remove(this.torus);
        this.GAME.physicsWorld.removeBody(this.body);
        this.GAME.TIME.removeEventListener('tick', this.tickHandler);
    }

    create() {
        const geometry = new TorusGeometry(0.5, 0.125, 16, 64);

        const material = new MeshStandardMaterial({
            color: 0xfcc742,
            emissive: 0x111111,
            metalness: 1,
            roughness: 0.5,
        });



        this.torus = new Mesh(geometry, material);
        this.torus.scale.set(this.size, this.size, this.size);
        this.torus.position.set(this.position.x, this.position.y, this.position.z);
        this.GAME.scene.add(this.torus);

        this.body = new CANNON.Body({
            mass: 0,
            position: new CANNON.Vec3(this.position.x, this.position.y, this.position.z),
            material: this.GAME.ballMaterial,
            collisionResponse: false
        });

        this.body.addShape(new CANNON.Cylinder(0.3125, 0.3125, 0.125, 16));
        this.body.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 2);
        this.GAME.physicsWorld.addBody(this.body);

        // Rotation quaternions
        const q1 = new CANNON.Quaternion();
        const q2 = new CANNON.Quaternion();
        const combined = new CANNON.Quaternion();
        q2.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 2);

        // Store tick handler to remove later
        this.tickHandler = () => {
            this.torus.rotation.y += 0.03;
            q1.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), this.torus.rotation.y);
            q1.mult(q2, combined);
            this.body.quaternion.copy(combined);
        };

        this.GAME.TIME.addEventListener('tick', this.tickHandler);

        this.body.addEventListener('collide', (event) => {
            if (!this.isHandled) {
                this.GAME.ring_hit = true;
                this.isHandled = true;
            }
            setTimeout(() => {
                this.destroy();
            }, 0);
        });
    }
}